var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14zM5.09 9.69c-.06.216-.09.374-.09.473 0 .283.111.493.334.63.223.138.474.207.754.207.495 0 .96-.167 1.396-.502.265-.203.648-.598 1.148-1.184l-.337-.173a5.003 5.003 0 0 1-.608.664c-.23.21-.423.316-.578.316a.354.354 0 0 1-.165-.039c-.05-.025-.075-.082-.075-.17 0-.088.045-.279.135-.574.035-.115.102-.323.202-.621L8.4 5.232l-.66.101c-.23.036-.622.079-1.175.129s-.975.083-1.265.098v.323c.345.012.583.038.713.078s.195.141.195.305a.392.392 0 0 1-.011.09 1.36 1.36 0 0 1-.026.095l-.923 2.75c-.07.203-.123.366-.158.49zM8.7 2.74c-.2-.16-.443-.24-.728-.24s-.53.08-.732.24c-.202.159-.304.352-.304.579 0 .227.102.421.304.583.203.161.447.242.732.242s.528-.08.728-.242c.2-.162.3-.356.3-.583 0-.227-.1-.42-.3-.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.f5b8f67045468868cfe58b2f8c193714.svg";
export { ForwardRef as ReactComponent };